__turbopack_context__.v({
  "blankRow": "subscription-module-scss-module___Q11qa__blankRow",
  "cardContent": "subscription-module-scss-module___Q11qa__cardContent",
  "cardHeader": "subscription-module-scss-module___Q11qa__cardHeader",
  "heroContainer": "subscription-module-scss-module___Q11qa__heroContainer",
  "heroContent": "subscription-module-scss-module___Q11qa__heroContent",
  "hoverLink": "subscription-module-scss-module___Q11qa__hoverLink",
  "hoverText": "subscription-module-scss-module___Q11qa__hoverText",
  "priceBox": "subscription-module-scss-module___Q11qa__priceBox",
  "priceValue": "subscription-module-scss-module___Q11qa__priceValue",
});
